import { configureStore } from '@reduxjs/toolkit';
import { windowReducer } from "./windowSlice";
import { scrollHeightReducer } from './scrollBarSlice';

export default configureStore({
    reducer: {
        window: windowReducer,
        scroll: scrollHeightReducer,
    }
});

